import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { PlanSummary } from '../models/plan-summary';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CoreApiService } from '../services/core-api.service';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { SnackBarComponent } from '../components/snackbar/snackbar.component';
import { VoluntaryCarriers } from "../models/voluntarycarriers";
import { MatRadioChange, MatRadioButton } from '@angular/material/radio';

@Component({
    selector: 'app-plan-card',
    templateUrl: './plan-card.component.html',
    styleUrls: ['./plan-card.component.scss']
})
export class PlanCardComponent implements OnInit {

    @Input() plan: PlanSummary;
    @Input() voluntaryCarrier: VoluntaryCarriers;
    @Input() isSelected: boolean;
    @Input() isPlanSelected: boolean;
    @Input() sendDataToPlanCard: string;
    @Input() carrierSelect : string;
    value: string = null
    markCarrierChecked : boolean = false;
    selectedRadioButtonValue: string = 'Selected';
    @Output() radioButtonSelectionChanged = new EventEmitter<string>();
    @Output() selectedCarrierName = new EventEmitter<string>();
    isCarrierSelected: boolean = false;
    carrierName: MatRadioButton;


    constructor(
        private api: CoreApiService,
        private route: ActivatedRoute,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private toast: MatSnackBar
    ) {
        this.matIconRegistry.addSvgIcon(
            'voluntary_icon',
            this.domSanitizer.bypassSecurityTrustResourceUrl(
                '../../assets/images/voluntary-icon.svg'
            )
        );
    }

    openSnackBar() {
        this.toast.openFromComponent(SnackBarComponent, {
                duration: 4000,
                horizontalPosition: 'left',
                verticalPosition: 'bottom'
            });
    }

    ngOnInit() {
    }

    ngOnChanges() {

        this.markCarrierChecked = false;
        this.markChecked();
    }

    carrierNameOnChange(mrChange: MatRadioChange) {
        this.carrierName = mrChange.value;
        this._selectedCarrierName();
        if (this.isPlanSelected) {
            this.isCarrierSelected = true;
        } 
    }

    markChecked() {
        if (this.voluntaryCarrier.code === this.carrierSelect) {
            this.markCarrierChecked = true;
            this.isPlanSelected = true;
        } else {
            this.markCarrierChecked = false;
            this.isPlanSelected = false;
        }
    }

    _selectedCarrierName() {
        this.isPlanSelected = false;
        if (this.sendDataToPlanCard.toString() === this.carrierName.toString()) {
            return this.isPlanSelected = true;
        } 
    }
}

